export const ITEMS_LIST = 'ITEMS_LIST';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const INCRESE_PRODUCT = 'INCRESE_PRODUCT';
export const SET_FILTERD_LIST = 'SET_FILTERD_LIST';

export const SET_USER_ORDER = 'SET_USER_ORDER';
export const SET_ORDER_PERSON_TYPE = 'SET_ORDER_PERSON_TYPE';
export const SET_PERSON_SEARCH = 'SET_PERSON_SEARCH';
export const SET_PERSON_OPTIONS = 'SET_PERSON_OPTIONS';
export const SET_SELECTED_PERSON = 'SET_SELECTED_PERSON';

export const SET_TRANSFER_MONEY = 'SET_TRANSFER_MONEY';